export enum QuantzBoolean {
  TRUE = '1',
  FALSE = '0',
}

export enum QuantzDevice {
  DESKTOP = 'desktop',
  PHONE = 'phone',
  TABLET = 'tablet',
}

export enum QuantzOS {
  WINDOWS = 'Windows',
  MAC = 'Mac',
  ANDROID = 'Android',
  IOS = 'iOS',
  LINUX = 'Linux',
  UBUNTU = 'Ubuntu',
}

export enum QuantzBrowser {
  CHROME = 'Chrome',
  CHROMIUM = 'Chromium',
  SAFARI = 'Safari',
  FIREFOX = 'Firefox',
  INTERNET_EXPLORER = 'IE',
  EDGE = 'Edge',
  OPERA = 'Opera',
}

export enum QuantzHjEventNameValue {
  U_TURN = 'uturn',
  RAGE_CLICK = 'rageclick',
}
